export const handleResponseError = (error: {
    response: { data: { message: any } }
  }) => {
    // console.log('error', error?.response?.data?.message)
    if (error?.response?.data) {
      throw error.response.data
    }
    throw error
  }


  // generate a random string of 6 digits
  export const generateRandomString = () => {
    return Math.floor(100000 + Math.random() * 900000).toString()
  }

  export function move(arr: [], old_index: number, new_index: number) {
    while (old_index < 0) {
      old_index += arr.length
    }
    while (new_index < 0) {
      new_index += arr.length
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length
      while (k-- + 1) {
        arr.push()
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
    return arr
  }
  